import { useState } from "react"
import { useWindowSize } from "rooks"
import { Button } from "@components/anti/Button"
import { Cover } from "@components/anti/Cover"
import { Image } from "@components/anti/Image"
import { Modal } from "@components/anti/Modal"
import { dataLayerPlayVideoHomePage } from "lib/datalayer"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact, getYoutubeEmbedUrl, imgUrl } from "src/mixins"

function HomeOverview({ data, locale }) {
  const [trigger, anim, inView] = useScrollAnim()
  const [showVideo, setShowVideo] = useState(false)

  return (
    <section className="sc-home-overview" ref={trigger}>
      <Modal
        id
        isShowing={showVideo}
        className="modal-home-overview modal-center modal-lg"
        hide={() => setShowVideo(false)}
      >
        <iframe
          title="home-overview-video"
          className="embed-video"
          frameBorder="0"
          src={`${getYoutubeEmbedUrl(
            locale === "id" ? data?.video_url : data?.video_url_en
          )}?autoplay=1`}
          allowFullScreen
          allow="autoplay"
        />
      </Modal>
      <div className={`img-wrapper ${inView ? "in-view" : ""}`}>
        {/* <div className="img-cover" /> */}
        <Image
          src={imgUrl(data?.banner_image_desktop)}
          className="img-cover banner-desktop"
          alt="banner-desktop"
          fill
        />
        <Image
          src={imgUrl(data?.banner_image_mobile)}
          className="img-cover banner-mobile"
          alt="banner-mobile"
          fill
        />
      </div>
      <div className="desktop-content-wrapper d-none d-md-block">
        <h2 className={`title ${anim(1)}`}>
          {convertHtmlToReact(data[`title_${locale}`])}
        </h2>
        <div className="container">
          <div className="row-bottom">
            <div className={`text ${anim(3)}`}>
              {convertHtmlToReact(data[`description_${locale}`])}
            </div>
            <Button
              iconLeft="ais ai-play"
              className={anim(5)}
              onClick={() => {
                dataLayerPlayVideoHomePage({
                  video_title: convertHtmlToReact(
                    data[`description_${locale}`]
                  ),
                })
                setShowVideo(true)
              }}
            >
              {data[`button_label_${locale}`]}
            </Button>
          </div>
        </div>
      </div>
      <div className="mobile-content-wrapper container d-flex d-md-none">
        <div>
          <h2 className={`title ${anim(1)}`}>
            {convertHtmlToReact(data[`title_${locale}`])}
          </h2>
          <Button
            iconLeft="ais ai-play"
            className={`${anim(3)}`}
            onClick={() => {
              dataLayerPlayVideoHomePage({
                video_title: convertHtmlToReact(data[`description_${locale}`]),
              })
              setShowVideo(true)
            }}
          >
            {data[`button_label_${locale}`]}
          </Button>
        </div>
        <div className={`text ${anim(5)}`}>
          {convertHtmlToReact(data[`description_${locale}`])}
        </div>
      </div>
    </section>
  )
}

export default HomeOverview
